import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=6916831a&scoped=true&"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VerticalNavMenu.vue?vue&type=style&index=1&id=6916831a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6916831a",
  null
  
)

export default component.exports